export default __webpack_public_path__ + "static/media/logo.5261ec65.jpg";